var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title-wrapper"},[_c('h1',{staticClass:"primary--text"},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.text)+" ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }